import { Router } from '@angular/router';
import { DialogService } from './dialog.service';
import { GlobalService } from './global.service';
import { JsonResult } from '../models/helper.model';
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";

@Injectable({
  providedIn: "root"
})
export class ShopService {

  public constructor(private http: HttpClient, private router: Router) { }

  GoToShopNamirialPay(currentuserid: string): void {
        
    // mynamirialemail : Questo è il Namirial Account collegato all'utente loggato.
    // serve nel caso di acquisto NamirialPay da parte di utenti INSIDE 
    // perchè in caso di SHOP utilizza l'account MyNamirial della licenza
    
    this.GetShopUrl(GlobalService.getUsedCompany(), false, 2, currentuserid).then(async (res) => {
      window.open(res.Value.toString(), "_self");
    }).catch((err) => {
      DialogService.Error(err.message);
    });
  }

  
  
  GoToShop(renewal: boolean = false, addon: number = 0): void {
    
    // addon = 0 Non è un addon
    // addon = 1 E' un addon di fatture aggiuntive
    // addon = 2 E' un addon di namirial pay
    // mynamirialemail : Questo è il Namirial Account collegato all'utente loggato.
    // serve nel caso di acquisto NamirialPay da parte di utenti INSIDE 
    // perchè in caso di SHOP utilizza l'account MyNamirial della licenza
    
    this.GetShopUrl(GlobalService.getUsedCompany(), renewal, addon, null).then(async (res) => {
      window.open(res.Value.toString(), "_self");
    }).catch((err) => {
      DialogService.Error(err.message);
    });
  }

  GetShopUrl(FK_Company: number, renewal: boolean, addon: number, currentuserid: string): Promise<JsonResult> {
    let url = environment.apiFullUrl + '/Shop/ShopPlus/' + FK_Company + '/' + renewal + '/' + addon + '/' + currentuserid;
    return this.http.get<JsonResult>(url).toPromise();
  }
}
